<mat-card class="filter settingHeader">
    <div class="name">
      Paychex API



    </div>
    <div class="quickAction">
        <mat-form-field>
            <mat-label>Paychex API's</mat-label>
            <mat-select  class="custom-select-style"   >               
              <mat-option  [value]="1">Add Worker</mat-option>
              <mat-option  value="1">Payment Worker</mat-option>
            </mat-select>
          </mat-form-field> 
    </div>

  </mat-card>


<mat-card class="apiListHolder">
    <div class="allApi">
        <ul>
            <li class="active" >Add Worker</li>
            <li>Payment Worker</li>
            <li>Company Checks</li>

            <li>Worker Check</li>
            <li>Company Pay Period</li>
        </ul>
    </div>
    <div class="new-datatable">  
        <!-- <div class="required-properties" >
          <div class="required-text">
            <h5>Some required properties are missing</h5>
            <p> Mismatched columns will not be imported         
              To complete your contacts import, you need <span class="color-dark">First Name</span> or <span class="color-dark">last Name</span> or <span class="color-dark">Email</span> as a Hubspot property. Please review your property mappings below or review the columns in your file.</p>
          </div>
        </div> -->
    
        <div class="table">
          <table>
            <thead>
              <th width="90px"> Sr. No.</th>
              <th width="130px">
                  <div class="inline-items-custom">
                      <mat-checkbox color="primary"></mat-checkbox>
                      Import <i class="fa fa-info-circle"   matTooltip="Only selected column header will be import"></i><br>
                   </div>            
              </th>
              <th>Column Header From File</th>         
              <th>System Fields</th>          
            </thead>       
            <tbody>
              <tr>           
                <td>f1</td>
                <td>
                  <div class="has-checkbox">
                    <mat-checkbox color="primary"></mat-checkbox>
                  </div>
                </td>           
                <td>Name</td>
                <td >             
                  <mat-form-field>
                    <mat-label>Choose fields</mat-label>
                    <mat-select  class="custom-select-style"   >               
                      <mat-option  [value]="1">1</mat-option>
                      <mat-option  value="1">2</mat-option>
                    </mat-select>
                  </mat-form-field> 
                 
                </td>                      
               </tr>         
            </tbody>
          </table>
        </div>
    </div>
</mat-card>
  